import { css } from "@emotion/react"

export const icon = css`
	box-sizing: border-box;
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;

	&.icon--expand {
		width: 100%;
		height: 100%;
	}

	svg {
		width: auto;
		height: 100%;
		display: block;
	}
`